<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="ch00_fm01"></a><a id="page_i">“READING PHILIP R. CRAIG IS ARMCHAIR<br/>TRAVELING AT ITS FINEST.”</a></p><a id="page_i">
<p class="center1">Alfred Hitchcock Mystery Magazine</p>
<p class="center"><strong>DEATH ON A VINEYARD BEACH</strong></p>
<p class="center">“THERE’S REAL CRIME HERE, GREED, BETRAYAL<br/>AND MURDER TIED IN A PLAUSIBLE PUZZLE, but<br/>Craig’s series owes most of its charm to the Vineyard<br/>and his intelligent, likable characters.”</p>
<p class="center">Publishers Weekly</p>
<p class="center">“JUST THE COMPANION FOR A DAY ON THE<br/>BEACH OR IN THE BACKYARD HAMMOCK . . .<br/>Close your eyes and imagine that Robert Parker’s<br/>Spencer had to enter the witness protection program.<br/>Now his name is J.W. Jackson, and he is<br/>summering on Martha’s Vineyard.”</p>
<p class="center">Mystery News</p>
<p class="center">“APPEALING… The humanization of the gangster<br/>family, the peeks behind the Vineyard facades, and the<br/>beach environment will win those who like their reading <br/>to be as leisurely as a long summer’s afternoon.”</p>
<p class="center">Boston Herald</p>
<p class="center">“ONE OF THE MOST UNDERRATED WRITERS IN<br/>THE GENRE… Craig is a consummate storyteller.”</p>
<p class="center">Murder &amp; Mayhem</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm01.vue?3fe19002